"use strict";

import axios from "axios";

import { getFirebaseIdToken } from "../features/auth/api";

export const postWithFirebaseAuth = async (url, data, config = {}) => {
    const firebaseIdToken = await getFirebaseIdToken();
    return axios.post(url, data, {
        ...config,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${firebaseIdToken}`,
            ...config.headers,
        },
    });
};

export const getWithFirebaseAuth = async (url, config = {}) => {
    const firebaseIdToken = await getFirebaseIdToken();
    return axios.get(url, {
        ...config,
        headers: {
            Authorization: `Bearer ${firebaseIdToken}`,
            ...config.headers,
        },
    });
};

export const deleteWithFirebaseAuth = async (url, config = {}) => {
    const firebaseIdToken = await getFirebaseIdToken();
    return axios.delete(url, {
        ...config,
        headers: {
            Authorization: `Bearer ${firebaseIdToken}`,
            ...config.headers,
        },
    });
};
